import { gql } from '@apollo/client';

const PRACTITIONER_BADGES = gql`
    query practitionerBadges($practitionerId: Int!) {
        practitionerProfileBadges(profileId: $practitionerId) {
            assertionGuid
            badgeClassName
        }
    }
`;

export default PRACTITIONER_BADGES;